import { useEffect } from 'react'
import { Header } from '@/components/layout/Header'
import { Footer } from '@/components/layout/Footer'

const GettingStarted = () => {
  useEffect(() => {
    document.title = 'Getting Started | BizMatch'
    const meta = document.querySelector('meta[name="description"]')
    if (meta) meta.setAttribute('content', 'Get started with BizMatch: create an account and list your first business.')
  }, [])

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-4 py-16">
        <h1 className="text-3xl font-bold text-primary mb-4">Getting Started</h1>
        <p className="text-muted-foreground max-w-3xl">1) Create an account 2) List your business 3) Go live and receive leads. We can add step-by-step content here.</p>
      </main>
      <Footer />
    </div>
  )
}

export default GettingStarted
